import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';

import { BannerCountdown } from '../components/BannerCountdown';
import { TranslatorComponent } from '../components/TranslatorComponent';
import { PUBLIC_PAGES_IDS } from '../constants';
import { reservationDataAtom } from '../jotai-atoms/reservation-data.atom';
import { userAtom } from '../jotai-atoms/user.atom';
import { User } from '../models/User';
import { ProfileService } from '../services/profile';
import { jrLightTheme } from '../theme/jr-light-theme';
import { NotificationProvider } from './NotificationProvider';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  const [user, setUser] = useAtom(userAtom);
  const [reservationData] = useAtom(reservationDataAtom);

  const refreshUserData = () => {
    if (!isSessionCheckerEnabled()) {
      return;
    }
    ProfileService.getMe().then((response) => {
      setUser({
        ...response.data,
        nextLiveClass: response.data.upcomingOrOpenLiveClass,
      } as User);
    });
  };

  useEffect(() => {
    refreshUserData();
  }, [reservationData?.forceRefreshUserData]);

  return (
    <ThemeProvider theme={jrLightTheme}>
      <TranslatorComponent>
        <NotificationProvider>
          <BannerCountdown show={!!user?.nextLiveClass} />
          {children}
        </NotificationProvider>
      </TranslatorComponent>
    </ThemeProvider>
  );
};

const isSessionCheckerEnabled = () => {
  const pageId = document.getElementById('root')?.getAttribute('page-id') || '';
  return !PUBLIC_PAGES_IDS.includes(pageId);
};
